'use strict';

import $ from 'jquery';

export default class TilesModule {
	constructor(selfInit = true) {
		let _this = this;
		_this.$el = $('[data-module="tilesModule"]');
		// let iconElement = document.querySelector('.icon-search');

		if(selfInit) {
			this.init(_this.$el);
			
			$('.tile-module__form-item .icon-search').on('click', (e) => {
				let $this = $(e.currentTarget);
				let parent = $this.parent();
				let queryString = parent.find('input').val();
	
				if (queryString) {
					let encodedString = encodeURI(queryString);
					let targetUrl = parent.data('target');
					let redirectIntUrl = targetUrl + '?language=German&zip=' + encodedString + '&town=' + encodedString;
					let redirectStringUrl = targetUrl + '?language=German&town=' + encodedString;
	
					if (Math.floor(encodedString) == encodedString && $.isNumeric(encodedString)) {
						window.location.href = redirectIntUrl;
					} else {
						window.location.href = redirectStringUrl;
					}
				}
			});
	
			$('.tile-module__form-item .tile-module__text-input input').on('keyup', (e) => {
				let $this = $(e.currentTarget);
	
				if (e.keyCode == 13){
					$this.next('.icon-search').trigger('click');
				}
			});
		} 
	}

	init($el){
		this.initAnimation($el);
			
		$(window).on('scroll', () => {
			this.initAnimation($el);
		});
	}

	initAnimation($el) {
		let offsetTop = $($el).offset().top,
		  scrollTrigger = $(window).height() * 0.8;

		if (!$el.hasClass('is-viewable')) {
			if (($(window).scrollTop() + scrollTrigger) > offsetTop) {
				$el.addClass('is-viewable');

				if($('.listing-results__events').length) {
					setTimeout(() => {
						$('.listing-results__events').addClass('animated view-changed');
					}, 1000);
				}
			}
		}
	}
}
